import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import VueSocketio from "vue-socket.io";

import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "bulma-pageloader";
import VueApexCharts from "vue-apexcharts";

import Admin from "@/components/pages/Admin";
import Home from "@/components/pages/Home";
import Inscription from "@/components/pages/Inscription";
import Repondre from "@/components/pages/Repondre";
import Dashboard from "@/components/pages/Dashboard";
import Consultation from "@/components/pages/Consultation";

import VueQriously from "vue-qriously";
import "bulma/css/bulma.css";
// Loading pour token admin
import Loading from "@/components/base/Loading";
// Copier des liens
import VueQr from "vue-qr";
import VueClipboard from "vue-clipboard2";
// Import de mon hack perso css bulma
require("@/assets/css/perso.css");
//import de fontawesome
require("../../static/fontawesome-free-5.9.0-web/css/all.css");

//to.params.url_participant
Vue.use(Router);
Vue.use(Buefy, { defaultIconPack: "fa" });
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueQriously);
Vue.use(VueClipboard);
Vue.use(VueQr);

//Vue.use(require('vue-moment'));

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/tokenLogin",
      name: "tokenLogin",
      component: Loading,
    },
    {
      path: "/i-:urlparticipant",
      name: "Inscription",
      component: Inscription,
    },
    {
      path: "/c-:urlresultat",
      name: "Consultation",
      component: Consultation,
    },
    {
      path: "/resultats-:url_moderateur/:type",
      name: "resultats",
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        Vue.use(VueSocketio, process.env.VUE_APP_NODE_SERVEUR);
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
        return;
      },
    },
    {
      path: "/r-:urlparticipant",
      name: "Repondre",
      component: Repondre,
      beforeEnter: (to, from, next) => {
        if (store.getters.id_participant != "-1") {
          next();
        } else window.location = process.env.VUE_APP_URL_INSIGHT;
      },
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          document.getElementsByTagName("html")[0].style.overflowX = "auto";
          next();
          return;
        } else window.location = process.env.VUE_APP_URL_SSO_FRONT;
      },
    },
  ],
});
